import { getDefaultPath } from '@iso/lib/helpers/url_sync';
import * as CONSTANTS from './constants';

const preKeys = getDefaultPath();
const initState = {
  // TODO: remove this field or use VIEW entity as value
  collapsed: window.innerWidth < 1220,
  openDrawer: false,
  openKeys: preKeys,
  showMobileMenu: false,
  allowDoAction: true,
  mobileOverlayMenuVisible: false,
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case CONSTANTS.TOGGLE_COLLAPSE_SIDEBAR:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case CONSTANTS.TOGGLE_MOBILE_OVERLAY_MENU:
      return {
        ...state,
        mobileOverlayMenuVisible: !state.mobileOverlayMenuVisible,
      };
    case CONSTANTS.COLLAPSE_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer,
      };

    case CONSTANTS.DISPLAY_MOBILE_MENU:
      return {
        ...state,
        showMobileMenu: !state.showMobileMenu,
      };

    case CONSTANTS.SELECTED_ITEM_MENU:
      return {
        ...state,
        allowDoAction: action.allowDoAction,
      };

    case CONSTANTS.SET_COLLAPSE_SIDEBAR:
      return {
        ...state,
        collapsed: action.payload
      };

    case CONSTANTS.CHANGE_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.payload,
      };
    case CONSTANTS.CLEAR_MENU:
      return {
        ...state,
        openKeys: [],
        current: [],
      };
    default:
      return state;
  }
  return state;
}
